<template>
  <link rel="stylesheet" href="CSS/App.css">
  <div>
    <div class="gradient-bg"></div>
    <div class="Process-header">
      <div class="h1 process-h1">
        <hr2 :data-column="'process_h1'" style="font-size: 1.3em;">{{ BranchPage.process_h1 }}</hr2>
      </div>
      <div class="p1 process-p1">
        <p :data-column="'process_p1'" v-html="BranchPage.process_p1"></p>
      </div>
    </div>
    <div class="p1 process-h2">
      <p :data-column="'process_h2'"
        >{{ BranchPage.process_h2 }}
      </p>
    </div>
    <div class="horizontal-line-1"></div>
    <div class="vertical-line"></div>
    <div class="process-info1">
    <div class="white-info">
      <div style="width: 480px; margin-bottom: 100px" class="info-block1">
        <div style="text-align: center" class="h1 process-h3">
          <hr2 :data-column="'process_h3'">{{ BranchPage.process_h3 }}</hr2>
        </div>
        <div class="p1 process-p2">
          <p :data-column="'process_p2'">
            {{ BranchPage.process_p2 }}</p>
        </div>
      </div>
      <div style="margin-bottom: 50px" class="horizontal-left"></div>
      <img alt="Image of parents holding up happy child" class="process-image1" :data-column="'process_image1'"
        :src=BranchPage.process_image1>
      </div>
    </div>
    <div style="display:flex; margin-top: 400px;" class="process-info2">
      <img alt="Couple meeting up with a loan officer" class="process-image2" :data-column="'process_image1'"
        :src=BranchPage.process_image2>
      <div style="margin-bottom: 50px" class="horizontal-right"></div>
      <div style="width: 480px; text-align: center; margin-right: 80px; margin-bottom: 100px" class="info-block2">
        <div class="h1 process-h4">
          <hr2 :data-column="'process_h4'">
            {{ BranchPage.process_h4 }}</hr2>
        </div>
        <div class="p1 process-p3">
          <p :data-column="'process_p3'" >
            {{ BranchPage.process_p3 }}</p>
        </div>
      </div>
    </div>
    <div style="display:flex; margin-top: 300px" class="process-info2">
      <div style="width: 480px; margin-bottom: 100px" class="info-block1">
        <div style="text-align: center" class="h1 process-h5">
          <hr2 :data-column="'process_h5'" style="position: absolute; right: 70%">{{ BranchPage.process_h5 }}</hr2>
        </div>
        <div class="p1 process-p4">
          <p :data-column="'process_p4'">
            {{ BranchPage.process_p4 }}</p>
        </div>
      </div>
      <div style="margin-bottom: 50px" class="horizontal-left"></div>
      <img alt="Family all together on a bed" class="process-image3" :data-column="'process_image1'"
        :src=BranchPage.process_image3>
    </div>
    <div style="display:flex; margin-top: 200px;" class="process-info2">
      <img alt="Family together for dinner" class="process-image4" :data-column="'process_image1'"
        :src=BranchPage.process_image4>
      <div style="margin-bottom: 50px" class="horizontal-right"></div>
      <div style="width: 480px; text-align: center; margin-right: 80px; margin-bottom: 100px" class="info-block2">
        <div class="h1 process-h6">
          <hr2 :data-column="'process_h7'">
            {{ BranchPage.process_h6 }}</hr2>
        </div>
        <div class="p1 process-p5">
          <p :data-column="'process_p5'">
            {{ BranchPage.process_p5 }}</p>
        </div>
      </div>
    </div>
    <div class="process-info1">
      <div class="info-block1">
        <div style="text-align: center" class="h1 process-h7">
          <hr2 :data-column="'process_h7'">{{ BranchPage.process_h7 }}</hr2>
        </div>
        <div class="p1 process-p6">
          <p :data-column="'process_p6'">
            {{ BranchPage.process_p6 }}</p>
        </div>
      </div>
      <div style="margin-bottom: 50px" class="horizontal-left"></div>
      <img alt="Picture of house" class="process-image5" :data-column="'process_image1'"
        style=" box-shadow: 12px 12px 24px grey; position: absolute; left: 55%"
        :src=BranchPage.process_image5>
    </div>
    <div style="display:flex; margin-top: 400px;" class="process-info2">
      <img alt="Couple after moving" class="process-image6" :data-column="'process_image1'"
        :src=BranchPage.process_image6>
      <div style="margin-bottom: 50px" class="horizontal-right"></div>
      <div style="width: 480px; text-align: center; margin-right: 80px; margin-bottom: 100px" class="info-block2">
        <div class="h1 process-h8">
          <hr2 :data-column="'process_h8'">
            {{ BranchPage.process_h8 }}</hr2>
        </div>
        <div class="p1 process-p7">
          <p :data-column="'process_p7'">
            {{ BranchPage.process_p7 }}</p>
        </div>
      </div>
    </div>
    <div class="bottom-header">
      <div class="h1 white-letters">
        <hr2 :data-column="'process_h9'" style="font-size: 2em; margin-right: 80px">{{ BranchPage.process_h9 }}</hr2>
      </div>
      <div style="margin-top: -80px; margin-bottom: 20px" class="h1 congrats">
        <hr2 class="congrats-text" :data-column="'process_h10'"
          v-html="BranchPage.process_h10"></hr2>
      </div>
      <KButton role="button" @click="sendTo('/find-loan')" :data-column="'process_button'" style="margin-bottom: 40px;" :size="null" :class="'custom-size3'"
        :theme-color="'null'" :rounded="'large'">{{ BranchPage.process_button }}</KButton>
    </div>
    <img alt="Goldstar star" style="position: absolute; left: 5%"
      src="https://uploads-ssl.webflow.com/62d16d4bfd1774e5fdff161d/62d16d4bfd17746111ff1667_Group%2013.png">
    <div class="show_bg1" style="text-align: center; margin-top: 80px">
      <hr2 class="loanOptions">Loan Options, Reimagined</hr2>
      <p style="color: white;  margin-top: 50px; padding-bottom: 50px; font-size: 1.2em">We've got you covered. Explored
        our loan options<br>that meet your needs.</p>
        <a role="button" href="mailto:humanresources@goldstarfinancial.com"><KButton @click="sendTo('/contact')" :size="null" :class="'custom-size3'" :theme-color="'null'" :rounded="'large'">Contact Us</KButton></a>
    </div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';
import apiService from '../api/api.service';
import { Button as KButton } from "@progress/kendo-vue-buttons";
import FooterComp from "../components/Footer_Comp.vue"

export default {
  name: "Proccess-Page",
  components: {
    FooterComp,
    KButton,
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,

    };
  },

  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    }

  }
};
</script>

<style>
.Process-header{
  text-align: center; margin-top: 80px;
}
.horizontal-line-1 {
  text-align: center;
  margin: 0 auto;
  margin-top: -20px;
  width: 865px;
  border-top: 1px solid #000;
}

.vertical-line {
  position: absolute;
  left: 50%;
  border-left: 2px solid #000;
  height: 2400px;
}

.horizontal-left {
  margin-top: 80px;
  position: absolute;
  right: 50%;
  border-top: 1px solid #000;
  width: 175px;
}

.horizontal-right {
  margin-top: 80px;
  position: absolute;
  left: 50%;
  border-top: 1px solid #000;
  width: 175px;
}
.bottom-header{
  text-align: center; margin-top: 700px;
}

.process-image1{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; left: 55%;
}
.process-image2{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; right: 60%;
}
.process-image3{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; left: 55%;
}
.process-image4{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; right: 60%;
}
.process-image5{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; left: 55%;
}
.process-image6{
  height: 270px; box-shadow: 12px 12px 24px grey; position: absolute; right: 60%;
}

.process-h2{
  font-size: 1.2em;
   margin-top: 100px;
   text-align: center;
   margin-right: 600px;
}

.process-h3{
  position: absolute; right: 70%;
}

.process-p2{
  width: 480px;font-size: .8em; position: absolute; right: 65%; margin-top: 60px;
}
.process-p3{
  font-size: .8em; position: absolute; left: 63%; width: 480px; margin-top: 60px; text-align: right;
}
.process-p4{
  width: 480px;font-size: .8em; position: absolute; right: 65%; margin-top: 60px;
}
.process-p5{
  font-size: .8em; position: absolute; left: 63%; width: 480px; margin-top: 60px; text-align: right;
}
.process-p6{
  width: 480px;font-size: .8em; position: absolute; right: 65%; margin-top: 60px;
}
.process-p7{
  font-size: .8em; position: absolute; left: 63%; width: 480px; margin-top: 60px; text-align: right;
}
.process-h4{
  text-align: center; position: absolute; left: 70%;
}
.process-h5{
  right: 70%; text-align: left;
}
.process-h6{
  text-align: center; position: absolute; left: 70%;
}
.process-h7{
  position: absolute; right: 70%;
}
.process-h8{
  text-align: center; position: absolute; left: 70%;
}
.info-block1{
  width: 480px; margin-bottom: 100px;
}
.info-block2{
  width: 480px;
  margin-top: 100px;
}
.congrats-text{
  font-size: 1.6em; line-height: 120%; font-family: museo-slab;
}
.loanOptions{
   color: #fff; font-size: 4.4em; margin-top: 40px;
}

@media (max-width: 460px){
  html, body {
      max-width: 100%;
      overflow-x: hidden;
  }
  .process-h1{
    margin-top: 120px;
  }
  .vertical-line{
    display: none;
  }
  body{
    position: relative;
  }
  .horizontal-left{
    display: none;
  }
  .horizontal-right{
    display: none;
  }
  .process-info1{
    display: block;
    z-index: 2;
    flex-direction: column;
  }
  .process-info2{
    flex-direction: column;
  }
  .process-p2{
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-h3{
    text-align: center;
    width: 90vw;
    left: 0%;
    right: 0%;
  }
  .process-image1{
    margin-top: 310px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 150px;
  }
  .process-h4{
    margin-top: 140px;
    width: 90vw;
    left: 0%;
  }
  .process-p3{
    margin-top: 200px;
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-image2{
    margin-top: 510px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 180px;
  }
  .process-h5{
    margin-top: 280px;
    position: absolute;
    width: 90vw;
    right: 0%;
    left: 55%;
  }
  .process-p4{
    margin-top: 380px;
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-image3{
    margin-top: 550px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 180px;
  }
  .process-h6{
    margin-top: 415px;
    left: 0%;
    right: 0%;
  }
  .process-p5{
    margin-top: 470px;
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-image4{
    margin-top: 770px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 200px;
  }
  .process-h7{
    margin-top: 715px;
    left: 0%;
    right: 0%;
  }
  .process-p6{
    margin-top: 770px;
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-image5{
    margin-top: 940px;
    left: 50%;
    transform: translateX(-55%);
    width: 300px;
    height: 137px;
  }
  .process-h8{
    position: absolute;
    margin-top: 740px;
    left: 0%;
    right: 0%;
  }
  .process-p7{
    margin-top: 820px;
    text-align: center;
    width: 90vw;
    right: 0%;
    left: 0%;
  }
  .process-image6{
    margin-top: 1090px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 170px;
  }
  .white-letters{
    display: none;
  }
  .bottom-header{
    margin-top: 1300px;
  }
  .congrats-text{
    font-size: 2.2rem;
  }
  .show_bg1{
    height: 400px;
  }
  .loanOptions{
    font-size: 2.1rem;
  }
}
</style>